import { createContext, useContext, ReactChild } from "react";

export const RouteContext = createContext<string>("");

export function useRoute() {
    return useContext(RouteContext);
}

export type RouteProviderProps = {
    readonly value: string;
    readonly children?: ReactChild;
};

export const RouteProvider = ({ value, children }: RouteProviderProps) => {
    return (
        <RouteContext.Provider value={value}>{children}</RouteContext.Provider>
    );
};
